module.exports = __webpack_public_path__ + "img/hohesLicht.f3119164.jpg";